export const instructionValuesKey = (values = {}) => JSON.stringify(
  Object.keys(values).sort().map(key => [key, values[key]])
);

export const instructionVariableErrors = (variables = [], values = {}) => variables.flatMap(variable => {
  const value = values[variable.key];
  const empty = value == null || String(value).trim() === "";
  let message = "";
  if (variable.required && empty) message = `Preencha ${variable.label || variable.key}.`;
  else if (!empty && variable.type === "number" && !Number.isFinite(Number(value))) message = `Informe um número válido em ${variable.label || variable.key}.`;
  else if (!empty && variable.type === "select" && !(variable.options || []).map(String).includes(String(value))) message = `Selecione uma opção válida em ${variable.label || variable.key}.`;
  else if (!empty && String(value).length > 5000) message = `Use até 5.000 caracteres em ${variable.label || variable.key}.`;
  return message ? [{ field: `variable.${variable.key}`, tab: 0, message }] : [];
});

export const instructionCompositionStale = form => !form.generatedPrompt ||
  form.composedValuesKey !== instructionValuesKey(form.values);

export const groupInstructionVariables = (variables = []) => {
  const groups = new Map();
  variables.forEach(variable => {
    const text = `${variable.key} ${variable.label || ""}`.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const group = variable.group || (/tom|voz|idioma|linguagem|tone/.test(text) ? "Comunicação"
      : /empresa|negocio|marca|company|site|endereco|horario/.test(text) ? "Empresa" : "Atendimento");
    groups.set(group, [...(groups.get(group) || []), variable]);
  });
  return Array.from(groups, ([label, fields]) => ({ label, fields }));
};
